import React, { useEffect, useState } from 'react';
import CircleLoader from "react-spinners/CircleLoader";
import About from '../components/HomePage/About/About';
import Blog from '../components/HomePage/Blog/Blog';
import Contact from '../components/HomePage/Contact/Contact';
import Footer from '../components/HomePage/Footer/Footer';
import Header from '../components/HomePage/Header/Header';
import Introduction from '../components/HomePage/Introduction/Introduction';
import Project from '../components/HomePage/Project/Project';
import Service from '../components/HomePage/Service/Service';
import Skill from '../components/HomePage/Skill/Skill';
import './Home.scss';


const Home = () => {
    const [loading, setLoading] = useState(true);
    useEffect(() => {
      setTimeout(() => {
        setLoading(false);
      }, 2000);
    }, []);
    return (
      <>
        {loading ? (
          <div className="preloader">
            <CircleLoader color="#F8E71C" size={110} loading={loading} />
          </div>
        ) : (
          <>
            <Header />
            <Introduction />
            <About />
            <Skill />
            <Project />
            <Service />
            <Blog />
            <Contact />
            <Footer />
          </>
        )}
      </>
    );
};

export default Home;